import React, { useState, useEffect } from "react";
import SFDrawer from "../drawer";
import SFLoadingSpinner from "../loadingSpinner";
import SFBullets from "../bullets/bullets";
import { getLongDate } from "../../services/dateService";
import { userService } from "../../index";
import SFAvatar from "../avatar";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import { SFCheckCircleOutline, SFSettingsIconFilled } from "../icons";
import getStyled from "../../hooks/getStyled";

import { useTranslation } from "react-i18next";

const { styled } = getStyled();

const SFAvatarStyled = styled(SFAvatar)(({ theme }) => ({
  width: "32px",
  height: "32px",
  fontSize: "14px",
}));

const StyledActive = styled("span")(({ theme }) => ({
  color: theme.palette.green400.main,
  ".MuiSvgIcon-root": {
    fontSize: "10px",
    marginRight: "2px",
  },
}));

const HistoryDrawer = ({ drawerOpen, setDrawerOpen, items, title }) => {
  const [history, setHistory] = useState({ loading: true });
  const { t } = useTranslation();

  useEffect(() => {
    if (items.loading) return;

    const populate = async () => {
      let userLookups = items.map((x) => {
        if (x.updatedBy !== userService.SYSTEM_MODIFIED_NAME) {
          return userService.getUserDetails(x.updatedBy);
        } else {
          return {
            userName: userService.SYSTEM_MODIFIED_NAME,
            name: userService.SYSTEM_MODIFIED_NAME,
            avatar: <SFSettingsIconFilled color="grey400" />,
          };
        }
      });
      const users = await Promise.all(userLookups);
      setHistory(
        items.map((x) => {
          let user = users.find((y) => y.userName?.toLowerCase() === x.updatedBy?.toLowerCase());
          return {
            name: user?.name,
            userName: user?.userName,
            avatar: user?.avatar ?? (
              <SFAvatarStyled name={user?.name || x.updatedBy} />
            ),
            updatedAt: x.updatedAt,
          };
        })
      );
    };

    populate();
  }, [items]);

  return (
    <SFDrawer
      open={drawerOpen}
      size="s"
      onClose={() => setDrawerOpen(false)}
      header={title || t("components.historyDrawer.title")}
      disableGutters={true}
    >
      {history.loading ? (
        <SFLoadingSpinner />
      ) : (
        <SFBullets
          dashed={false}
          bullets={history.map((x, index) => ({
            color: "grey200",
            icon: x.avatar,
            element: (
              <SFStack>
                <SFTypography variant="rightPanelLabel">
                  {x.name || x.userName}
                </SFTypography>
                {x.userName !== userService.SYSTEM_MODIFIED_NAME &&
                  !!x.userName &&
                  x.name && (
                  <SFTypography variant="body2">{x.userName}</SFTypography>
                )}
                <SFTypography variant="body2">
                  {index == 0 && (
                    <StyledActive>
                      <SFCheckCircleOutline />
                      {t("components.historyDrawer.active")}
                    </StyledActive>
                  )}{" "}
                  {getLongDate(x.updatedAt)}
                </SFTypography>
              </SFStack>
            ),
          }))}
        />
      )}
    </SFDrawer>
  );
};

export default HistoryDrawer;
